import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; // 🟢 KHÔI PHỤC THEME GỐC BẢO VỆ NAVBAR
import { 
    Box, Button, Container, Grid, Card, CardContent, Typography, 
    TextField, CircularProgress 
} from "@mui/material";
import { WorkspacePremiumOutlined, SaveOutlined } from "@mui/icons-material";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import { useEffect, useState } from "react";

// ==========================================
// THEME CHUẨN KÈM FONT PLUS JAKARTA SANS
// ==========================================
const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF", marginBottom: "24px" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none' } } }
    }
});

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

function SettingProfit() {
    const [setting, setSetting] = useState();
    const [load, setLoad] = useState(true);
    
    // Mảng 60 cấp độ để render giao diện
    const levels60 = Array.from({ length: 60 }, (_, i) => i + 1);

    useEffect(() => {
        if (load === true) {
            axios.get(`${process.env.REACT_APP_API_URL}/profit/get`, {}).then((res) => {
                setSetting(res.data.data[0]);
                setLoad(false);
            });
        }
    }, [load]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoad(true);
        
        // Khởi tạo formData
        const formData = {
            id: setting?._id,
        };

        // Lấy dữ liệu từ 180 ô nhập liệu, xóa bỏ các dấu phẩy để lưu đúng định dạng Number
        for (let i = 1; i <= 60; i++) {
            formData[`nap${i}`] = Number((e.target[`nap${i}`].value || "").replace(/,/g, '')) || 0;
            formData[`top${i}`] = Number((e.target[`top${i}`].value || "").replace(/,/g, '')) || 0;
            formData[`v${i}`] = Number((e.target[`v${i}`].value || "").replace(/,/g, '')) || 0;
        }

        axios
            .put(`${process.env.REACT_APP_API_URL}/profit/update`, formData)
            .then((res) => {
                setLoad(false);
                swal(t('success'), "Cập nhật cấp độ VIP thành công!", "success");
            })
            .catch((res) => {
                setLoad(false);
                swal(t('error'), "Có lỗi xảy ra", "error");
            });
    };

    // Component tạo ô nhập liệu có chức năng tự động Format số tiền (vd: 1,000,000)
    const SettingInput = ({ label, name, defaultValue, highlightColor }) => {
        const [displayValue, setDisplayValue] = useState("");

        useEffect(() => {
            if (defaultValue !== undefined && defaultValue !== null) {
                setDisplayValue(Number(defaultValue).toLocaleString("en-US"));
            }
        }, [defaultValue]);

        const handleChange = (e) => {
            // Xóa toàn bộ chữ và ký tự đặc biệt, chỉ giữ lại số
            const rawValue = e.target.value.replace(/[^0-9]/g, '');
            if (rawValue) {
                // Fomat lại với dấu phẩy
                setDisplayValue(Number(rawValue).toLocaleString("en-US"));
            } else {
                setDisplayValue("");
            }
        };

        return (
            <Grid item xs={12} sm={6} md={4} sx={{ '@media (min-width: 1200px)': { flexBasis: '20%', maxWidth: '20%' } }}>
                <Typography variant="caption" fontWeight="800" color="#7E8299" mb={1} display="flex" alignItems="center" gap={0.5} textTransform="uppercase">
                    {highlightColor && <Box sx={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: highlightColor }} />}
                    {label}
                </Typography>
                <TextField 
                    fullWidth 
                    name={name} 
                    id={name} 
                    type="text" 
                    value={displayValue}
                    onChange={handleChange}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: '#F9F9F9',
                            height: '42px',
                            '& fieldset': { borderColor: '#E4E6EF' },
                            '&:hover fieldset': { borderColor: '#B5B5C3' },
                            '&.Mui-focused fieldset': { borderColor: highlightColor || '#1B84FF', borderWidth: '1px' },
                        },
                        '& .MuiInputBase-input': { 
                            height: '42px', padding: '0 14px', boxSizing: 'border-box',
                            fontSize: '0.9rem', color: '#181C32', fontWeight: 600
                        }
                    }} 
                />
            </Grid>
        );
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                
                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-vip-zone * { font-family: 'Plus Jakarta Sans', sans-serif !important; }
                    `}</style>

                    <Box className="safe-vip-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)' }}>
                        
                        {load && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' }}>
                                <CircularProgress size={50} sx={{ color: '#FFC700' }} />
                            </Box>
                        )}

                        <Container maxWidth="xl">
                            
                            {/* HEADER */}
                            <Box mb={4} display="flex" alignItems="center" gap={1.5}>
                                <WorkspacePremiumOutlined sx={{ fontSize: '2.5rem', color: '#FFC700' }} />
                                <Box>
                                    <Typography variant="h4" fontWeight="800" color="#181C32">Cấu Hình {t("setting")} VIP</Typography>
                                    <Typography variant="body2" color="text.secondary">Thiết lập điều kiện thăng cấp và phần thưởng</Typography>
                                </Box>
                            </Box>

                                <form onSubmit={handleSubmit}>
                                    
                                    {/* 1. MỨC NẠP LÊN VIP (60 Cấp) */}
                                    <Card>
                                        <CardContent sx={{ p: 4 }}>
                                            <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                <Box sx={{width: '6px', height: '24px', backgroundColor: '#1B84FF', borderRadius: '4px'}}></Box> MỨC NẠP YÊU CẦU ĐỂ LÊN CẤP (1 - 60)
                                            </Typography>
                                            <Grid container spacing={3}>
                                                {levels60.map(level => (
                                                    <SettingInput 
                                                        key={`nap${level}`} 
                                                        label={`Mức nạp lên VIP ${level}`} 
                                                        name={`nap${level}`} 
                                                        defaultValue={setting?.[`nap${level}`]} 
                                                        highlightColor="#1B84FF"
                                                    />
                                                ))}
                                            </Grid>
                                        </CardContent>
                                    </Card>

                                    {/* 2. THƯỞNG THĂNG CẤP (60 Cấp) */}
                                    <Card>
                                        <CardContent sx={{ p: 4 }}>
                                            <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                <Box sx={{width: '6px', height: '24px', backgroundColor: '#50CD89', borderRadius: '4px'}}></Box> THƯỞNG THĂNG CẤP ({t("top_reward")}) (1 - 60)
                                            </Typography>
                                            <Grid container spacing={3}>
                                                {levels60.map(level => (
                                                    <SettingInput 
                                                        key={`top${level}`} 
                                                        label={`Thưởng khi lên VIP ${level}`} 
                                                        name={`top${level}`} 
                                                        defaultValue={setting?.[`top${level}`]} 
                                                        highlightColor="#50CD89"
                                                    />
                                                ))}
                                            </Grid>
                                        </CardContent>
                                    </Card>

                                    {/* 3. QUÀ SINH NHẬT (60 Cấp) */}
                                    <Card>
                                        <CardContent sx={{ p: 4 }}>
                                            <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                <Box sx={{width: '6px', height: '24px', backgroundColor: '#F1416C', borderRadius: '4px'}}></Box> QUÀ SINH NHẬT ({t('saving_rate')}) (1 - 60)
                                            </Typography>
                                            <Grid container spacing={3}>
                                                {levels60.map(level => (
                                                    <SettingInput 
                                                        key={`v${level}`} 
                                                        label={`Quà Sinh Nhật VIP ${level}`} 
                                                        name={`v${level}`} 
                                                        defaultValue={setting?.[`v${level}`]} 
                                                        highlightColor="#F1416C"
                                                    />
                                                ))}
                                            </Grid>
                                        </CardContent>
                                    </Card>

                                    {/* NÚT LƯU STICKY */}
                                    <Box sx={{ position: 'sticky', bottom: 20, zIndex: 10, mt: 4, display: 'flex', justifyContent: 'center' }}>
                                        <Button 
                                            type="submit" 
                                            variant="contained" 
                                            color="primary" 
                                            startIcon={<SaveOutlined />}
                                            sx={{ 
                                                py: 1.5, px: 8, fontSize: '1.1rem', fontWeight: 800, borderRadius: '50px', 
                                                backgroundColor: '#181C32', color: '#FFF',
                                                boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
                                                transition: 'all 0.3s',
                                                '&:hover': { transform: 'translateY(-3px)', backgroundColor: '#3F4254', boxShadow: '0px 15px 40px rgba(0, 0, 0, 0.3)' }
                                            }}
                                        >
                                            {t("save")} CẤU HÌNH VIP
                                        </Button>
                                    </Box>

                                </form>
                          
                        </Container>
                    </Box>
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SettingProfit;